<template>
    <div>
        <div style="padding-top: 15px">
            <el-button type="primary" @click="showEditFunc()">新增</el-button>
            <div class="common-search">
                <template v-if="permissions.osm_at_super_distribution">
                    属性：
                    <el-select style="margin-right: 10px" v-model="visitLevel">
                        <el-option
                                v-for="item of visitLevelOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </template>

                状态：
                <el-select style="margin-right: 10px" v-model="status">
                    <el-option
                            v-for="item of statusOptions"
                            :key="item.label"
                            :label="item.label"
                            :value="item.value"/>
                </el-select>
            </div>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="filterList" height="100%" row-key="userId"
                      :span-method="arraySpanMethod">
                <el-table-column align="center" :label="clubName">
                    <el-table-column align="center" min-width="120" label="时间段">
                        <template slot-scope="scope">
                            {{scope.row.startTime | timeText}} - {{scope.row.endTime | timeText}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="玩家ID" prop="userShowId"/>
                    <el-table-column align="center" label="玩家昵称" prop="nickName"/>
                    <el-table-column align="center" min-width="120" label="类型">
                        <template slot-scope="scope">{{scope.row.userType | userTypeName}}</template>
                    </el-table-column>
                    <template v-if="permissions.osm_at_super_distribution">
                        <el-table-column align="center" label="盲注" prop="blind">
                          <template slot-scope="scope">{{scope.row.blind | blindCount}}</template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="属性">
                            <template slot-scope="scope">{{scope.row.visitLevel | visitLevelName}}</template>
                        </el-table-column>
                    </template>
                    <el-table-column align="center" label="可用金豆" prop="availChip"/>
                    <el-table-column align="center" min-width="120" label="不可用金豆数量" prop="nonAvailChip"/>
                    <el-table-column align="center" label="牌局数" prop="rmNum"/>
                    <el-table-column align="center" label="总手数" prop="hdNum"/>
                    <el-table-column
                            align="center"
                            label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status === 'on'?'开启':'终止'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="showEditFunc(2,scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup" style="width: 400px">
                <h3>{{form.op===1?'AT新增':'AT编辑'}}</h3>
                <el-form ref="ATRuleForm" size="medium" :model="form" :rules="rules" class="common-popup-table"
                         label-width="90px">
                    <el-form-item v-if="form.op===1" label="玩家ID：" prop="randomId">
                        <el-input type="textarea" resize="none" v-model="form.randomId" placeholder="请输入玩家ID，多个用 , 分隔"/>
                    </el-form-item>
                    <el-form-item label="时间段：" prop="time">
                        <el-select v-model="form.time">
                            <el-option
                                    v-for="item of etTimeOptions"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型：" prop="userType">
                        <el-select v-model="form.userType">
                            <el-option
                                    v-for="item of userTypeOptions"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value"/>
                        </el-select>
                    </el-form-item>
<!--                    <el-form-item label="盲注：" prop="smallblind">-->
<!--                        <el-select v-model="form.smallblind">-->
<!--                            <el-option-->
<!--                                    v-for="item of smallblindOptions"-->
<!--                                    :key="item.label"-->
<!--                                    :label="item.label"-->
<!--                                    :value="item.value"/>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                  <el-form-item label="盲注：" prop="smallblind" placeholder="请填写小盲值">
                    <el-input-number v-model="form.smallblind"></el-input-number>
                  </el-form-item>
                    <el-form-item v-if="form.op===1&&permissions.osm_at_super_distribution" label="属性："
                                  prop="visitLevel">
                        <el-select v-model="form.visitLevel">
                            <el-option
                                    v-for="item of formVisitLevelOptions"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="游戏类型："
                                  prop="gameType">
                        <el-select v-model="form.roomPath">
                            <el-option
                                    v-for="item of formGameTypeOptions"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-switch
                                v-model="form.status"
                                active-value="on"
                                inactive-value="off"
                                active-text="开启"
                                inactive-text="终止"/>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('ATRuleForm')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('ATRuleForm')">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapActions} from 'vuex'
    import {mobileCountryCodeOptions} from 'mixins'

    export default {
        mixins: [mobileCountryCodeOptions],
        data() {
            return {
                clubId: null,
                show: false,
                clubName: 'XXX俱乐部',
                loading: false,
                list: [],
                visitLevel: '',// 属性
                visitLevelOptions: [
                    {label: '全部', value: ''},
                    {label: '超级用户', value: 'operator'},
                    {label: '普通用户', value: 'normal'}
                ],
                status: '',// 状态
                statusOptions: [
                    {label: '全部', value: ''},
                    {label: '开启', value: 'on'},
                    {label: '终止', value: 'off'},
                ],
                form: {
                    op: null,// 新增：1 编辑：2
                    randomId: '',
                    time: '',
                    userType: '',
                    smallblind: '',
                    visitLevel: 'normal',
                    status: '',
                    roomPath:'',
                    roomPathLabel:''
                },
                rules: {
                    randomId: [
                        {required: true, message: '请输入玩家ID', trigger: 'blur'},
                    ],
                    time: [
                        {required: true, message: '请选择时间段', trigger: 'blur'},
                    ],
                    userType: [
                        {required: true, message: '请选择类型', trigger: 'blur'},
                    ],
                    smallblind: [
                        {required: true, message: '请选择盲注', trigger: 'blur'},
                    ]
                },
                userTypeOptions: [// 类型
                    // {label: '紧聪', value: 'smartUp'},
                    // {label: '松聪', value: 'smartDown'},
                    // {label: '紧', value: 'up'},
                    // {label: '松', value: 'down'},
                    {label: '中小级别盈利型', value: 1},//normalSmart
                    {label: '中小级别均衡型', value: 2},//normalBalance
                    {label: '中小级别大鱼型', value: 3},//normalFool
                    {label: '大级别盈利型', value: 4},//highSmart
                    {label: '大级别均衡型', value: 5},//highBalance
                    {label: '大级别大鱼型', value: 6},//highFool
                ],
                smallblindOptions: [// 盲注
                    {label: '1/2', value: '1'},
                    {label: '2/4', value: '2'},
                    {label: '5/10', value: '5'},
                    {label: '10/20', value: '10'},
                    {label: '20/40', value: '20'},
                    {label: '25/50', value: '25'},
                    {label: '50/100', value: '50'},
                ],
                formVisitLevelOptions: [// 属性
                    {label: '超级用户', value: 'operator'},
                    {label: '普通用户', value: 'normal'}
                ],
                formGameTypeOptions:[// 游戏类型
                    {label: '德州', value: '61'},
                    {label: 'AOF', value: '63'}
                ]
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
            ...mapGetters('at', ['etTimeOptions', 'etStartTimeArr']),
            filterList() {
                let arr = this.list.filter(item => {
                    if (!this.visitLevel || this.visitLevel === item.visitLevel) {
                        if (!this.status || this.status === item.status) {
                            return true
                        }
                    }
                });

                let startIndex = arr.length - 1;
                let rowspan = 1;
                if (arr.length === 1) {
                    arr[0].colspan = 1;
                    arr[0].rowspan = 1;
                } else {
                    for (let i = arr.length - 2; i >= 0; i--) {
                        if (arr[startIndex].startTime[0] !== arr[i].startTime[0]) {
                            startIndex = i;
                            arr[i + 1].colspan = 1;
                            arr[i + 1].rowspan = rowspan;
                            rowspan = 1;
                            if (i === 0) {
                                arr[0].colspan = 1;
                                arr[0].rowspan = rowspan;
                            }
                        } else {
                            if (i === 0) {
                                arr[0].colspan = 1;
                                arr[0].rowspan = rowspan + 1;
                            } else {
                                rowspan++;
                                arr[i + 1].colspan = 0;
                                arr[i + 1].rowspan = 0;
                            }
                        }
                    }
                }

                return arr
            }
        },
        filters: {
            timeText(arr) {
                function if0(text) {
                    return text === 0 ? '00' : text
                }

                return `${if0(arr[0])}:${if0(arr[1])}`;
            },
            userTypeName(type) {
                let arr = ['中小级别盈利型', '中小级别均衡型', '中小级别大鱼型', '大级别盈利型', '大级别均衡型', '大级别大鱼型'];
                return arr[type - 1];
            },
            blindCount(val) {
              const str = val.split('/');
              return str[0]/100+'/'+str[1]/100;
            },
            visitLevelName(type) {
                switch (type) {
                    case 'normal':
                        type = '普通用户';
                        break;
                    case 'operator':
                        type = '超级账户';
                        break;
                    default:
                        break;
                }
                return type;
            }
        },
        created() {
            this.clubId = this.$route.query.clubId;
            this.clubName = this.$route.query.clubName;
            this.getList();
            // this.getETDetail();
        },
        methods: {
            ...mapActions('user', ['checkUser']),
            ...mapActions('at', ['getATList', 'addAT', 'updateAT', 'getETDetail']),
            arraySpanMethod({row, columnIndex}) {
                if (columnIndex === 0) {
                    return {
                        rowspan: row.rowspan,
                        colspan: row.colspan
                    };
                }
            },
            getList() {
                this.loading = true;
                this.getATList(this.clubId).then(res => {
                    this.loading = false;
                    var time = [];
                    this.etStartTimeArr.forEach(item => {
                        time[item] = [];
                    });
                    if (res.data) {
                        res.data.forEach(item => {
                            time[item.startTime[0]].push(item)
                        });
                    }
                    let list = [];
                    this.etStartTimeArr.forEach(item => {
                        list = list.concat(time[item])
                    });
                    this.list = list;
                })
            },
            showEditFunc(op = 1, obj = null) {
                this.form.op = op;
                if (op === 2) {
                    let startTime = obj.startTime.map(t => {
                        return t < 10 ? '0' + t : t;
                    }).join(':');
                    let endTime = obj.endTime.map(t => {
                        return t < 10 ? '0' + t : t;
                    }).join(':');
                    if(obj.roomPath == '61'){
                        obj.roomPath = '德州'
                    }else if(obj.roomPath == '63'){
                        obj.roomPath = 'AOF'
                    }
                    this.form = Object.assign({}, this.form, {
                        randomId: obj.userShowId,
                        time: `${startTime} - ${endTime}`,
                        smallblind: obj.blind.split('/')[0],
                        userType: +obj.userType,
                        visitLevel: null,
                        status: obj.status,
                        roomPath: obj.roomPath
                    })
                }
                this.show = true;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let {time, randomId, op, ...params} = this.form;
                        this.checkUser(randomId.split(',').map(n => +n)).then(res => {
                            let arr = res.data.filter(item => {
                                if (randomId.indexOf(item.userIdShow) < 0) {
                                    return item
                                }
                            });
                            if (arr.length) {
                                this.$alert(`没有找到：${arr.toString()}`);
                                return
                            }
                            time = time.split('-');
                            params.userId = res.data.map(c => c.userId);
                            params.startTime = time[0];
                            params.endTime = time[1];
                            if (op === 1) {
                                params.clubId = this.clubId;
                                params.smallblind=params.smallblind*100;
                                this.addAT(params).then(() => {
                                    this.$message.success('添加成功');
                                    this.getList();
                                    this.close(formName)
                                })
                            } else {
                                if(params.roomPath == '德州'){
                                    params.roomPath = '61'
                                }else if(params.roomPath == 'AOF'){
                                    params.roomPath = '63'
                                }
                                params.smallblind=params.smallblind*100;
                                this.updateAT(params).then(() => {
                                    this.$message.success('修改成功');
                                    this.getList();
                                    this.close(formName)
                                })
                            }
                        });
                    }
                });
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            }
        }
    }
</script>